import { Drawer, Form, Button, Space, Grid } from 'antd'
import type { FormInstance } from 'antd'

const { useBreakpoint } = Grid

interface FormDrawerProps {
  title: string
  open: boolean
  onClose: () => void
  onSubmit?: () => void
  loading?: boolean
  form: FormInstance
  children: React.ReactNode
  width?: number
  hideSubmit?: boolean
}

export default function FormDrawer({
  title,
  open,
  onClose,
  onSubmit,
  loading,
  form,
  children,
  width = 480,
  hideSubmit = false,
}: FormDrawerProps) {
  // Responsive width: phones take full viewport, tablets cap at 80vw,
  // desktop uses whatever the caller passed.
  // The global mobile.css ALSO enforces this at CSS level for safety
  // — applies to every <Drawer />, not just FormDrawer — but doing
  // it at the prop level here avoids a flash before the CSS lands.
  const screens = useBreakpoint()
  const isPhone = !screens.md  // < 768px
  const isTablet = !!screens.md && !screens.lg  // 768-1023px
  let effectiveWidth: number | string = width
  if (isPhone) effectiveWidth = '100vw'
  else if (isTablet) effectiveWidth = Math.min(
    width, Math.round(window.innerWidth * 0.8),
  )

  return (
    <Drawer
      title={title}
      open={open}
      onClose={onClose}
      width={effectiveWidth}
      destroyOnClose
      extra={
        <Space wrap>
          <Button onClick={onClose}>{hideSubmit ? 'Close' : 'Cancel'}</Button>
          {!hideSubmit && onSubmit && (
            <Button type="primary" loading={loading} onClick={onSubmit}>
              Save
            </Button>
          )}
        </Space>
      }
    >
      <Form form={form} layout="vertical">
        {children}
      </Form>
    </Drawer>
  )
}
